import CryptoJS from "crypto-js";

// Simple cache to store decrypted values based on the encrypted string
const decryptionCache = {};

function DecryptData(dncToken) {
  let value = localStorage.getItem(dncToken);
  if (value) {
    // If the value is already in cache, return it
    if (decryptionCache[value]) {
      return decryptionCache[value];
    }

    try {
      let data = CryptoJS.AES.decrypt(value, process.env.REACT_APP_ACCESS_KEY);
      let final = data.toString(CryptoJS.enc.Utf8);

      if (!final) {
        return "";
      }

      let before = JSON.parse(final);

      // Store in cache
      decryptionCache[value] = before;

      return before;
    } catch (error) {
      console.error("Decryption or Parsing Error:", error);
      return "";
    }
  } else {
    return "";
  }
}

export default DecryptData;
